import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component
export default class ScreenIsWideEnough extends Vue {
  get screenIsWideEnough() {
    return this.$vuetify.breakpoint.width > 1600;
  }
}
